import UsersService from '../../services/UsersService';
import toast from 'react-hot-toast';

// Action Types
export const GET_USERS_REQUEST = 'GET_USERS_REQUEST';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_FAILED = 'GET_USERS_FAILED';

export const GET_USER_BY_ID_REQUEST = 'GET_USER_BY_ID_REQUEST';
export const GET_USER_BY_ID_SUCCESS = 'GET_USER_BY_ID_SUCCESS';
export const GET_USER_BY_ID_FAILED = 'GET_USER_BY_ID_FAILED';

export const GET_USER_WITH_ROLES_REQUEST = 'GET_USER_WITH_ROLES_REQUEST';
export const GET_USER_WITH_ROLES_SUCCESS = 'GET_USER_WITH_ROLES_SUCCESS';
export const GET_USER_WITH_ROLES_FAILED = 'GET_USER_WITH_ROLES_FAILED';

export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAILED = 'CREATE_USER_FAILED';

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILED = 'UPDATE_USER_FAILED';

export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAILED = 'DELETE_USER_FAILED';

export const ASSIGN_ROLE_REQUEST = 'ASSIGN_ROLE_REQUEST';
export const ASSIGN_ROLE_SUCCESS = 'ASSIGN_ROLE_SUCCESS';
export const ASSIGN_ROLE_FAILED = 'ASSIGN_ROLE_FAILED';

export const GET_USER_ROLE_ASSIGNMENTS_REQUEST = 'GET_USER_ROLE_ASSIGNMENTS_REQUEST';
export const GET_USER_ROLE_ASSIGNMENTS_SUCCESS = 'GET_USER_ROLE_ASSIGNMENTS_SUCCESS';
export const GET_USER_ROLE_ASSIGNMENTS_FAILED = 'GET_USER_ROLE_ASSIGNMENTS_FAILED';

export const REMOVE_ROLE_ASSIGNMENT_REQUEST = 'REMOVE_ROLE_ASSIGNMENT_REQUEST';
export const REMOVE_ROLE_ASSIGNMENT_SUCCESS = 'REMOVE_ROLE_ASSIGNMENT_SUCCESS';
export const REMOVE_ROLE_ASSIGNMENT_FAILED = 'REMOVE_ROLE_ASSIGNMENT_FAILED';

export const CLEAR_CURRENT_USER = 'CLEAR_CURRENT_USER';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const RESET_USER_SUCCESS = 'RESET_USER_SUCCESS';

// Action Creators

// Get all users with pagination and filtering
export const getUsersAction = (params = {}) => async (dispatch) => {
    try {
        dispatch({ type: GET_USERS_REQUEST });
        
        const response = await UsersService.getAllUsers(params);
        
        if (response.success) {
            dispatch({
                type: GET_USERS_SUCCESS,
                payload: response.data
            });
        } else {
            dispatch({
                type: GET_USERS_FAILED,
                payload: response.message || 'Failed to fetch users'
            });
        }
    } catch (error) {
        dispatch({
            type: GET_USERS_FAILED,
            payload: error.message || 'Failed to fetch users'
        });
    }
};

// Get user by ID
export const getUserByIdAction = (id) => async (dispatch) => {
    try {
        dispatch({ type: GET_USER_BY_ID_REQUEST });
        
        const response = await UsersService.getUserById(id);
        
        if (response.success) {
            dispatch({
                type: GET_USER_BY_ID_SUCCESS,
                payload: response.data
            });
        } else {
            dispatch({
                type: GET_USER_BY_ID_FAILED,
                payload: response.message || 'Failed to fetch user'
            });
        }
    } catch (error) {
        dispatch({
            type: GET_USER_BY_ID_FAILED,
            payload: error.message || 'Failed to fetch user'
        });
    }
};

// Get user with roles
export const getUserWithRolesAction = (id) => async (dispatch) => {
    try {
        dispatch({ type: GET_USER_WITH_ROLES_REQUEST });
        
        const response = await UsersService.getUserWithRoles(id);
        
        if (response.success) {
            dispatch({
                type: GET_USER_WITH_ROLES_SUCCESS,
                payload: response.data
            });
        } else {
            dispatch({
                type: GET_USER_WITH_ROLES_FAILED,
                payload: response.message || 'Failed to fetch user with roles'
            });
        }
    } catch (error) {
        dispatch({
            type: GET_USER_WITH_ROLES_FAILED,
            payload: error.message || 'Failed to fetch user with roles'
        });
    }
};

// Create new user
export const createUserAction = (userData, navigate) => async (dispatch) => {
    try {
        dispatch({ type: CREATE_USER_REQUEST });
        
        const response = await UsersService.createUser(userData);
        
        if (response && response.success === true) {
            dispatch({
                type: CREATE_USER_SUCCESS,
                payload: response.data
            });
            
            toast.success(response.message || "User created successfully!");
            dispatch(resetUserSuccess());
            if (navigate) {
                navigate('/users');
            }
        } else {
            // Handle validation errors
            if (response.data && Array.isArray(response.data) && response.data.length > 0) {
                dispatch({
                    type: CREATE_USER_FAILED,
                    payload: {
                        message: response.message || 'Validation errors',
                        validationErrors: response.data
                    }
                });
            } else {
                dispatch({
                    type: CREATE_USER_FAILED,
                    payload: {
                        message: response.message || 'Failed to create user',
                        validationErrors: null
                    }
                });
            }
            
            toast.error(response.message || "Failed to create user");
        }
    } catch (error) {
        // Handle validation errors from API response
        if (error.data && Array.isArray(error.data) && error.data.length > 0) {
            dispatch({
                type: CREATE_USER_FAILED,
                payload: {
                    message: error.message || 'Validation errors',
                    validationErrors: error.data
                }
            });
        } else {
            const errorMessage = error.message || 'Failed to create user';
            dispatch({
                type: CREATE_USER_FAILED,
                payload: {
                    message: errorMessage,
                    validationErrors: null
                }
            });
        }
        
        // Don't show toast for validation errors, let the form handle them
        if (!error.data || !Array.isArray(error.data) || error.data.length === 0) {
            toast.error(error.message || "Failed to create user");
        }
    }
};

// Update user
export const updateUserAction = (id, userData, navigate) => async (dispatch) => {
    try {
        dispatch({ type: UPDATE_USER_REQUEST });
        
        const response = await UsersService.updateUser(id, userData);
        
        if (response && response.success === true) {
            dispatch({
                type: UPDATE_USER_SUCCESS,
                payload: response.data
            });
            
            toast.success(response.message || "User updated successfully!");
            dispatch(resetUserSuccess());
            if (navigate) {
                navigate('/users');
            }
        } else {
            // Handle validation errors
            if (response.data && Array.isArray(response.data) && response.data.length > 0) {
                dispatch({
                    type: UPDATE_USER_FAILED,
                    payload: {
                        message: response.message || 'Validation errors',
                        validationErrors: response.data
                    }
                });
            } else {
                dispatch({
                    type: UPDATE_USER_FAILED,
                    payload: {
                        message: response.message || 'Failed to update user',
                        validationErrors: null
                    }
                });
            }
            
            toast.error(response.message || "Failed to update user");
        }
    } catch (error) {
        // Handle validation errors from API response
        if (error.data && Array.isArray(error.data) && error.data.length > 0) {
            dispatch({
                type: UPDATE_USER_FAILED,
                payload: {
                    message: error.message || 'Validation errors',
                    validationErrors: error.data
                }
            });
        } else {
            const errorMessage = error.message || 'Failed to update user';
            dispatch({
                type: UPDATE_USER_FAILED,
                payload: {
                    message: errorMessage,
                    validationErrors: null
                }
            });
        }
        
        // Don't show toast for validation errors, let the form handle them
        if (!error.data || !Array.isArray(error.data) || error.data.length === 0) {
            toast.error(error.message || "Failed to update user");
        }
    }
};

// Delete user
export const deleteUserAction = (id) => async (dispatch) => {
    try {
        dispatch({ type: DELETE_USER_REQUEST });
        
        const response = await UsersService.deleteUser(id);
        
        if (response && response.success === true) {
            dispatch({
                type: DELETE_USER_SUCCESS,
                payload: id
            });
            
            toast.success(response.message || "User deleted successfully!");
            dispatch(resetUserSuccess());
        } else {
            dispatch({
                type: DELETE_USER_FAILED,
                payload: response.message || 'Failed to delete user'
            });
            
            toast.error(response.message || "Failed to delete user");
        }
    } catch (error) {
        const errorMessage = error.message || 'Failed to delete user';
        
        dispatch({
            type: DELETE_USER_FAILED,
            payload: errorMessage
        });
        
        toast.error(errorMessage);
    }
};

// Assign role to user
export const assignRoleAction = (roleData) => async (dispatch) => {
    try {
        dispatch({ type: ASSIGN_ROLE_REQUEST });
        
        const response = await UsersService.assignRole(roleData);
        
        if (response.success) {
            dispatch({
                type: ASSIGN_ROLE_SUCCESS,
                payload: response.data
            });
            
            toast.success("Role assigned successfully!");
            dispatch(resetUserSuccess());
        } else {
            dispatch({
                type: ASSIGN_ROLE_FAILED,
                payload: response.message || 'Failed to assign role'
            });
            
            toast.error(response.message || "Failed to assign role");
        }
    } catch (error) {
        const errorMessage = error.message || 'Failed to assign role';
        
        dispatch({
            type: ASSIGN_ROLE_FAILED,
            payload: errorMessage
        });
        
        toast.error(errorMessage);
    }
};

// Get user role assignments
export const getUserRoleAssignmentsAction = (userId) => async (dispatch) => {
    try {
        dispatch({ type: GET_USER_ROLE_ASSIGNMENTS_REQUEST });
        
        const response = await UsersService.getUserRoleAssignments(userId);
        
        if (response.success) {
            dispatch({
                type: GET_USER_ROLE_ASSIGNMENTS_SUCCESS,
                payload: response.data
            });
        } else {
            dispatch({
                type: GET_USER_ROLE_ASSIGNMENTS_FAILED,
                payload: response.message || 'Failed to fetch role assignments'
            });
        }
    } catch (error) {
        dispatch({
            type: GET_USER_ROLE_ASSIGNMENTS_FAILED,
            payload: error.message || 'Failed to fetch role assignments'
        });
    }
};

// Remove role assignment
export const removeRoleAssignmentAction = (assignmentId) => async (dispatch) => {
    try {
        dispatch({ type: REMOVE_ROLE_ASSIGNMENT_REQUEST });
        
        const response = await UsersService.removeRoleAssignment(assignmentId);
        
        if (response.success) {
            dispatch({
                type: REMOVE_ROLE_ASSIGNMENT_SUCCESS,
                payload: assignmentId
            });
            
            toast.success("Role assignment removed successfully!");
            dispatch(resetUserSuccess());
        } else {
            dispatch({
                type: REMOVE_ROLE_ASSIGNMENT_FAILED,
                payload: response.message || 'Failed to remove role assignment'
            });
            
            toast.error(response.message || "Failed to remove role assignment");
        }
    } catch (error) {
        const errorMessage = error.message || 'Failed to remove role assignment';
        
        dispatch({
            type: REMOVE_ROLE_ASSIGNMENT_FAILED,
            payload: errorMessage
        });
        
        toast.error(errorMessage);
    }
};

// Clear current user
export const clearCurrentUser = () => ({
    type: CLEAR_CURRENT_USER
});

// Clear errors
export const clearErrors = () => ({
    type: CLEAR_ERRORS
});

// Reset user success state
export const resetUserSuccess = () => ({
    type: RESET_USER_SUCCESS
});